<!-- Stats Bar -->
<div class="container-fluid">
    <div class="stats-container ">
        <div class="stat-item">
            <div class="stat-label">{{ "profileOverview.submitted" | translate }} <i class="bi bi-send"></i></div>
            <div class="stat-value">{{ stats.submitted }}</div>
        </div>
        <div class="stat-item">
            <div class="stat-label">{{ "profileOverview.active" | translate }} <i class="bi bi-lightning-fill"></i></div>
            <div class="stat-value">{{ stats.active }}</div>
        </div>
        <div class="stat-item">
            <div class="stat-label">{{ "profileOverview.interviews" | translate }} <i class="bi bi-calendar-check"></i></div>
            <div class="stat-value">{{ stats.interviews }}</div>
        </div>
        <div class="stat-item">
            <div class="stat-label">{{ "profileOverview.accepted" | translate }} <i class="bi bi-check-circle"></i></div>
            <div class="stat-value">{{ stats.accepted }}</div>
        </div>
        <div class="stat-item">
            <div class="stat-label">{{ "profileOverview.rejected" | translate }} <i class="bi bi-x-circle"></i></div>
            <div class="stat-value">{{ stats.rejected }}</div>
        </div>
        <div class="stat-item">
            <div class="stat-label">{{ "profileOverview.saved" | translate }} <i class="bi bi-bookmark"></i></div>
            <div class="stat-value">{{ stats.saved }}</div>
        </div>
    </div>

    <!-- Main Content -->
    <div class="main-content">
        <!-- Left Column -->
        <div class="left-column">

            <!-- Upcoming Interviews Section -->
            <div class="card interviews-card">
                <div class="card-header">
                    <h3 class="section-title">
                        <i class="bi bi-calendar-event"></i>
                        <span>{{ "profileOverview.upcomingInterviews" | translate }}</span>
                    </h3>
                    <button class="view-calendar-btn" (click)="onViewCalendar()">{{ "profileOverview.viewCalendar" | translate }}</button>
                </div>

                <div class="interviews-list">
                    <div *ngFor="let interview of interviews" class="interview-item">
                        <div class="interview-content">
                            <div class="interview-icon">
                                <i class="bi bi-person-circle"></i>
                            </div>
                            <div class="interview-details">
                                <h4 class="interview-position">{{ interview.position }}</h4>
                                <p class="interview-company">{{ interview.company }} · {{ interview.type }}</p>
                                <p class="interview-date">{{ interview.date }}</p>
                            </div>
                        </div>
                        <button class="join-btn" (click)="onJoinInterview(interview)">
                            <i class="bi bi-play-fill"></i>
                            <span>{{ interview.joinLabel | translate }}</span>
                        </button>
                    </div>
                </div>
            </div>

            <!-- AI Career Tools Section -->
            <div class="career-tools-card">
                <h3 class="section-title">
                    <i class="bi bi-robot"></i>
                    <span>{{ "profileOverview.aiCareerTools" | translate }}</span>
                </h3>

                <div class="tools-grid">
                    <div *ngFor="let tool of careerTools" class="tool-card">
                        <div class="tool-icon">
                            <i [class]="tool.icon"></i>
                        </div>
                        <h4 class="tool-title">{{ tool.title | translate }}</h4>
                        <p class="tool-description">{{ tool.description | translate }}</p>
                        <div class="tool-footer">
                            <span class="tool-badge" [class]="'badge-' + tool.actionColor" *ngIf="tool.badgeLabel">
                                {{ tool.badgeLabel | translate }}
                            </span>
                            <button class="tool-action-btn" [class]="'action-' + tool.actionColor">
                                {{ tool.actionLabel | translate }} <i class="bi bi-arrow-right"></i>
                            </button>
                        </div>
                    </div>
                </div>
            </div>

            <!-- Top Matches Section -->
            <div class="card matches-card">
                <div class="card-header">
                    <h3 class="section-title">
                        <i class="bi bi-star-fill"></i>
                        <span>{{ "profileOverview.topMatches" | translate }}</span>
                    </h3>
                </div>

                <div class="matches-grid">
                    <div *ngFor="let job of jobMatches" class="match-card">
                        <div class="match-header">
                            <div>
                                <h3 class="job-title">{{ job.title }}</h3>
                                <p class="job-company">{{ job.company }}</p>
                                <p class="job-location">📍 {{ job.location }}</p>
                            </div>
                            <div class="match-percentage">
                                <span class="percentage">{{ job.matchPercentage }}%</span>
                                <span class="match-label">{{ "profileOverview.match" | translate }}</span>
                            </div>
                        </div>
                        <div class="job-badge">{{ job.badge }}</div>
                        <button class="view-details-btn" (click)="onViewDetails(job)">{{ "profileOverview.viewDetails" | translate }}</button>
                    </div>
                </div>
            </div>

        </div>

        <!-- Right Column -->
        <div class="right-column">

            <!-- Profile Strength -->
            <div class="card profile-strength-card">
                <div class="card-header">
                    <h3 class="section-title">
                        <i class="bi bi-graph-up"></i>
                        <span>{{ "profileOverview.profileStrength" | translate }}</span>
                    </h3>
                </div>

                <div class="card-body">
                    <div class="strength-circle">
                        <svg viewBox="0 0 120 120" class="progress-ring">
                            <circle class="progress-ring-circle-bg" cx="60" cy="60" r="50" />
                            <circle class="progress-ring-circle" cx="60" cy="60" r="50"
                                style="stroke-dasharray: 314; stroke-dashoffset: 69.08;" />
                        </svg>
                        <div class="strength-text">{{ profileStrength }}%</div>
                    </div>

                    <div class="strength-checklist">
                        <div class="checklist-item">
                            <span class="check-icon completed">✓</span>
                            <span>{{ "profileOverview.workHistory" | translate }}</span>
                        </div>
                        <div class="checklist-item">
                            <span class="check-icon completed">✓</span>
                            <span>{{ "profileOverview.education" | translate }}</span>
                        </div>
                        <div class="checklist-item">
                            <span class="check-icon incomplete">✗</span>
                            <span>{{ "profileOverview.addProfileLink" | translate }}</span>
                        </div>
                        <div class="checklist-item">
                            <span class="check-icon incomplete">✗</span>
                            <span>{{ "profileOverview.addReferences" | translate }}</span>
                        </div>
                    </div>

                    <button class="complete-profile-btn" (click)="onGenerateProfile()">{{ "profileOverview.completeProfile" | translate }}</button>
                </div>
            </div>

            <!-- Snapshot -->
            <div class="card snapshot-card">
                <div class="card-header">
                    <h3 class="section-title">
                        <i class="bi bi-camera-reels"></i>
                        <span>{{ "profileOverview.snapshot" | translate }}</span>
                    </h3>
                </div>

                <div class="card-body">
                    <div class="snapshot-stats">
                        <div *ngFor="let stat of snapshotStats" class="snapshot-stat">
                            <div class="snapshot-value">{{ stat.value }}</div>
                            <div class="snapshot-label">{{ stat.label | translate }}</div>
                        </div>
                    </div>
                </div>
            </div>

            <!-- Generated by upcareer -->
            <div class="card generated-card">
                <div class="card-header">
                    <h3 class="section-title">
                        <i class="bi bi-file-earmark-text"></i>
                        <span>{{ "profileOverview.generatedBy" | translate }}</span>
                    </h3>
                    <button class="add-btn" (click)="onGenerateCoverLetter()">
                        <i class="bi bi-plus"></i>
                        {{ "profileOverview.generateCoverLetter" | translate }}
                    </button>
                </div>

                <div class="card-body">
                    <div class="documents-list">
                        <div *ngFor="let doc of generatedDocuments" class="document-item">
                            <i class="bi bi-file-pdf doc-icon"></i>
                            <div class="doc-info">
                                <p class="doc-name">{{ doc.name }}</p>
                                <p class="doc-date">{{ doc.date }}</p>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

        </div>
    </div>
</div>